module.exports = __webpack_public_path__ + "img/step4-d.cd347053.png";